import api from "../../index";

export const GetAllRulesApi = (params) => api.get(`RuleMaster/GetAllRule?${params}`);
export const UpdateUserStatusApi = (data) => api.patch(`RuleMaster/Active-InActive-Rule?${data}`, );
export const UpdateRulesApi = (data) => api.put('RuleMaster/Update-Rule', data);
export const GetrulesByIdApi = (traderId) => api.get(`RuleMaster/GetRuleById/${traderId}`);
export const addRulesApi = (data) => api.post('RuleMaster/Create-Rule', data);